import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
export interface IMemberListProps {
  trailer: any;
  onClose: Function;
  OnAction: Function;
}
export function TransporterTrailerList({
  trailer,
  OnAction = () => {},
  onClose = () => {},
}: IMemberListProps) {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClose(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  const { t } = useTranslation();

  return (
    <div
      className="grid grid-cols-12 gap-5 px-7 py-8 border-b border-primary "
      key={trailer?._id}
    >
      <div className="col-span-3 grid grid-cols-7 gap-5">
        <img
          src="/assets/icons/sidebar/inventory.svg"
          alt="avatar"
          className="inline col-span-2 self-center"
        />
        <div className="col-span-5  ">
          <p className="text-sm text-blue/[0.5]">
            {t("trailers_page.trailer_number")}
          </p>
          <div>
            <p className="text-sm">{trailer?.number ?? "N/A"}</p>
          </div>
        </div>
      </div>
      <div className="col-span-8"></div>
      <div className=" ">
        <div className="relative float-left">
          <img
            src="/assets/icons/chevon_right_red.svg"
            alt="lock"
            className="inline ltr:float-right rtl:float-left rtl:rotate-180 cursor-pointer"
            onClick={() => OnAction(trailer)}
          />
        </div>
      </div>
    </div>
  );
}
